import { CircularProgress, Divider, Grid, Typography, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faXTwitter, faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useSelector } from 'react-redux';
import { useStylesCompanyDetails } from '../styles/widgetStyles';

const ContactDetailsFromCompanyDetailsWidget = ({ token, columns }) => {
	const theme = useTheme();
	const classes = useStylesCompanyDetails(theme);
	const companyDetailsResponse = useSelector(({ fuse }) => fuse.form.companyDetailsResponse);
	const channelCompanyDetails = useSelector(
		({ fuse }) => fuse.form.channelSettings?.value?.company?.companyContactViewModel
	);
	const {
		address,
		address2,
		address3,
		city,
		province,
		country,
		postalCode,
		contactNumber,
		contactEMail,
		facebook,
		twitter,
		instagram,
		linkedIn
	} =
		(token === 'TOKEN'
			? companyDetailsResponse?.value?.companyContactViewModel || channelCompanyDetails
			: channelCompanyDetails) || {};

	return (
		<Grid container className="mt-16 mb-16" justifyContent="center" alignItems="center">
			<Grid item xs={12} md={columns || 8}>
				<Typography variant="h6">Contact Details</Typography>
				<Divider />
				<br />
				{companyDetailsResponse?.status !== 'pending' && (
					<>
						<Grid container spacing={2}>
							<Grid item xs={12} md={4} className="text-center">
								<FontAwesomeIcon style={classes.icon} icon={faLocationDot} size="lg" />
								<Typography>
									{address} {address2} {address3} {city} {province} {country} {postalCode}
								</Typography>
							</Grid>
							{contactNumber && (
								<Grid item xs={12} md={4} className="text-center">
									<FontAwesomeIcon style={classes.icon} icon={faPhone} size="lg" />
									<Typography>{contactNumber}</Typography>
								</Grid>
							)}
							{contactEMail && (
								<Grid item xs={12} md={4} className="text-center">
									<button
										style={{ cursor: 'pointer' }}
										onClick={() => {
											if (contactEMail) {
												window.open(`mailto:${contactEMail}`);
											}
										}}
									>
										<FontAwesomeIcon style={classes.icon} size="lg" icon={faEnvelope} />
										<Typography>{contactEMail}</Typography>
									</button>
								</Grid>
							)}
						</Grid>
						<br />
						<br />
						<Grid container spacing={4} justifyContent="center">
							{facebook && (
								<Grid item xs={12} sm={4} className="text-center">
									<FontAwesomeIcon
										style={classes.clickableIcon}
										size="xl"
										icon={faFacebook}
										onClick={() => {
											if (facebook) {
												window.open(facebook);
											}
										}}
									/>
									<Typography>Facebook</Typography>
								</Grid>
							)}
							{twitter && (
								<Grid item xs={12} sm={4} className="text-center">
									<FontAwesomeIcon
										style={classes.clickableIcon}
										size="xl"
										icon={faXTwitter}
										onClick={() => {
											if (twitter) {
												window.open(twitter);
											}
										}}
									/>
									<Typography>X</Typography>
								</Grid>
							)}
							{instagram && (
								<Grid item xs={12} sm={4} className="text-center">
									<FontAwesomeIcon
										style={classes.clickableIcon}
										size="xl"
										icon={faInstagram}
										onClick={() => {
											if (instagram) {
												window.open(instagram);
											}
										}}
									/>
									<Typography>Instagram</Typography>
								</Grid>
							)}
							{linkedIn && (
								<Grid item xs={12} sm={4} className="text-center">
									<FontAwesomeIcon
										style={classes.clickableIcon}
										size="xl"
										icon={faLinkedin}
										onClick={() => {
											if (linkedIn) {
												window.open(linkedIn);
											}
										}}
									/>
									<Typography>LinkedIn</Typography>
								</Grid>
							)}
						</Grid>
					</>
				)}

				{companyDetailsResponse?.status === 'pending' && (
					<div className={classes.loadingContainer}>
						<CircularProgress size="3rem" />
					</div>
				)}
			</Grid>
		</Grid>
	);
};

export default ContactDetailsFromCompanyDetailsWidget;
